module.exports = __webpack_public_path__ + "img/paymentgateway.bd350d3a.jpg";